import React, { useState } from 'react';
import { useDictionary } from 'lib/utils';
import Icon from 'components/helpers/Icon';
import classNames from 'classnames/bind';
import styles from './PlanOptionsListingGraphQL.module.scss';
import { PlanListingSortingProps, SortingOption } from '../Types/Plans.Type';

const PlanListingSorting: React.FC<PlanListingSortingProps> = (props) => {
  const cx = classNames.bind(styles);
  const sortByLabel = useDictionary('Sort by');

  const { sortingOptions, defaultSelection, displayType, updatePlansSortOrder } = props;

  const [selectedSortingOption, setSelectedSortingOption] = useState<SortingOption | null>(
    sortingOptions ? sortingOptions[0] : null
  );
  const [sortOptionsDisplayed, setSortOptionsDisplayed] = useState<boolean>(false);

  const onSortOptionChange = (sortingOption: SortingOption) => {
    setSelectedSortingOption(sortingOption);
    updatePlansSortOrder(sortingOption);
    setSortOptionsDisplayed(false);
  };

  if (defaultSelection && sortingOptions) {
    const useOption =
      sortingOptions.find((sortOpt) => sortOpt.displayName == defaultSelection) ??
      sortingOptions.find((sortOpt) => sortOpt.fieldName == defaultSelection);
    if (useOption && selectedSortingOption != useOption) {
      setSelectedSortingOption(useOption);
    }
  }

  if (!selectedSortingOption) {
    return <></>;
  }

  return (
    <h3 className={cx('sort-by', `display-type-${displayType}`, { 'sort-by__active': sortOptionsDisplayed })}>
      <span>{sortByLabel}</span>
      <button
        type="button"
        className={cx('sort-by__drop-down')}
        onClick={() => setSortOptionsDisplayed(!sortOptionsDisplayed)}
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key == 'Enter' || event.key == ' ') setSortOptionsDisplayed(!sortOptionsDisplayed);
        }}
      >
        {selectedSortingOption?.title}
        <Icon variant="carat" className={cx('drop-down-icon')} />
      </button>
      {sortOptionsDisplayed && sortingOptions && (
        <ul className={cx('sort-by__options-container', `display-type-${displayType}`)}>
          {sortingOptions.map((sortingOption, index) => {
            return (
              <li
                key={`plan-sort-${index}`}
                className={cx('sort-by__options-container-option', {
                  selected: sortingOption.id === selectedSortingOption.id,
                })}
                aria-current={sortingOption.id === selectedSortingOption.id ? 'true' : undefined}
                title={`${sortByLabel} ${sortingOption.title}`}
                onClick={() => onSortOptionChange(sortingOption)}
                onKeyDown={(event) => {
                  if (event.key == 'Enter' || event.key == ' ') onSortOptionChange(sortingOption);
                }}
                tabIndex={0}
              >
                {sortingOption.title}
                {sortingOption.id === selectedSortingOption.id && <Icon variant="checkmark" />}
              </li>
            );
          })}
        </ul>
      )}
    </h3>
  );
};

export default PlanListingSorting;
